import { Location } from "../../svgs/Location";
import { Modal } from "../Modal";
import { QuoteBanner } from "../QuoteBanner";
import ShowCase from "../ShowCase";
import { useState } from "react";

const Home = () => {

    const [modalOpen, setModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState(null);

    const openModal = (image) => {
        setModalImage(image);
        setModalOpen(true);
    }

    return <div className="home-page">
        <Modal imageUrl={modalImage} isOpen={modalOpen} closeModal={() => setModalOpen(false)} />

        <div className="hero-image-container">
            <div className="hero-text">
                <Location />Based in Oamaru, serving the wider Otago area; Dunedin, Mosgiel, Timaru, Central Otago.
            </div>
            <img className="hero-image" src="https://i.imgur.com/fyqqLDd.jpeg" alt="Image of Nathan painting a roof" />
        </div>

        <ShowCase first_image='https://i.imgur.com/dyQh2pT.jpeg' second_image='https://i.imgur.com/HEyNoGy.jpeg' />

        <div className="content process-section">
            <span>Restore and protect your roof with a professional system designed to extend its life and enhance its appearance.</span>
            <br />

            <span className="header">Iron & Colorsteel Roof Restoration</span>
            <span>Our process begins with the application of a powerful biocide treatment to eliminate moss, mould, and lichen at the root, preventing regrowth. 
                The roof is then thoroughly cleaned to remove all contaminants and prepare the surface for restoration. We replace all worn or compromised fasteners to ensure structural integrity and carry out targeted rust treatment to stop corrosion in its tracks. 
                A high-performance primer is then applied, followed by two coats of premium industrial roof coating. This complete system restores durability, improves weather resistance, and delivers a fresh, modern finish backed by a 15-year paint warranty.</span>
            <br />
            
            <span className="header">Metal Tile & Decramastic Tile Roof Restoration</span>
            <span>We restore metal tile and decramastic roofs using a proven multi-step process. First, we apply specialised biocides to eliminate moss and mould, followed by a deep clean to remove dirt and debris. Decramastic tiles are then rechipped to restore their 
                original texture and protective layer. Finally, we apply advanced industrial coatings specifically designed for these roof types, bringing them back to new condition. The result is a revitalised roof with enhanced protection and a 15-year paint warranty.</span>
            <br />

<span className="header">Concrete Tile Roof Restoration</span>
            <span>Concrete tile roofs are carefully cleaned to remove built-up grime and biological growth. Damaged or broken tiles are replaced, and ridge caps are repointed to ensure structural strength and weatherproofing. We then apply specialised sealing coatings to 
                protect the porous surface of the tiles, followed by two coats of high-quality industrial roof coating. This process not only restores the roof’s appearance but also significantly improves its durability, all backed by a 15-year paint warranty.</span>
                <br />
                <span>No matter the roof type, our restoration systems are designed to protect, rejuvenate, and extend the life of your roof—saving you the cost of premature replacement while delivering a clean, durable, and long-lasting finish.</span>

        </div>

        <div className="before-after-section">
                <div className="image image-one">
                    <img className="before-image" src="https://i.imgur.com/BD7qfE1.jpeg" alt="Before roof painting" onClick={() => openModal("https://i.imgur.com/BD7qfE1.jpeg")} />
                    <span>Before</span>
                </div>
                <div className="image image-two">
                    <img className="after-image" src="https://i.imgur.com/CmAfQcb.jpeg" alt="After roof painting" onClick={() => openModal("https://i.imgur.com/CmAfQcb.jpeg")} />
                    <span>After</span>
                </div>
        </div>

        <div className="content quote-section">
            <span>FREE QUOTES</span>
            <a className="phone-link" href="tel:0275184992"><span>027 518 4992</span></a>
        </div>

        <div className="section-container">
         <div className="before-after-section">
                <div className="image image-one">
                    <img className="before-image" src="https://i.imgur.com/pDUhdcL.jpeg" alt="Before roof painting" onClick={() => openModal("https://i.imgur.com/pDUhdcL.jpeg")} />
                    {/* <span>Before</span> */}
                </div>
                <div className="image image-two">
                    <img className="after-image" src="https://i.imgur.com/xjY0V29.jpeg" alt="After roof painting" onClick={() => openModal("https://i.imgur.com/xjY0V29.jpeg")} />
                    {/* <span>After</span> */}
                </div>
         </div>

          <div className="before-after-section">
                <div className="image image-one">
                    <img className="before-image" src="https://i.imgur.com/kEMz7u7.jpeg" alt="Before roof painting" onClick={() => openModal("https://i.imgur.com/kEMz7u7.jpeg")} />
                    {/* <span>Before</span> */}
                </div>
                <div className="image image-two">
                    <img className="after-image" src="https://i.imgur.com/s9C7t8v.jpeg" alt="After roof painting" onClick={() => openModal("https://i.imgur.com/s9C7t8v.jpeg")} />
                    {/* <span>After</span> */}
                </div>
         </div>

         <div className="before-after-section">
                <div className="image wide-image">
                    <img className="before-image" src="https://i.imgur.com/kKns7my.jpeg" alt="Before roof painting" onClick={() => openModal("https://i.imgur.com/kKns7my.jpeg")} />
                    {/* <span>Before</span> */}
                </div>
         </div>
        </div>

        <div className="content testimonials">
            <span className="header">Testimonials</span>
            <div className="testimonial">
                <img src="https://i.imgur.com/0bmtTFf.jpeg" alt="Customer image placeholder" />
                <div className="text-container">
                    <span>"Great service, arrived when they said and kept us informed through the whole process."</span>
                    <span className="name">Stephen</span>
                </div>
            </div>
            <div className="testimonial">
                <img src="https://i.imgur.com/0bmtTFf.jpeg" alt="Customer image placeholder" />
                <div className="text-container">
                    <span>"Nathan was masterful in reaching all the really inaccessible parts of our heritage stone building when we recently repainted the entire exterior. It was critical work since Heritage New Zealand were subsidising the whole project. We are thrilled with the outcome. Certainly we wouldn’t hesitate to recommend Nathan."</span>
                    <span className="name">Greg</span>
                </div>
            </div>
            <div className="testimonial">
                <img src="https://i.imgur.com/0bmtTFf.jpeg" alt="Customer image placeholder" />
                <div className="text-container">
                    <span>"Nathan did an excellent job painting our roof, very professional and timely. Very affordable too! Would highly recommend"</span>
                    <span className="name">Chris</span>
                </div>
            </div>

            <div className="review-section">
                <span>Happy with our service? We'd love to hear from you!</span><br />
                <a className="review-button" href="https://g.page/r/CdRI_LoYTLOGEAE/review" target="_blank" rel="noopener noreferrer">
                    Write a Google Review
                </a>
            </div>
        </div>

        <div className="before-after-section">
                <div className="image spreader-image">
                    <img src="https://i.imgur.com/siDZu9V.jpeg" alt="Before roof painting" onClick={() => openModal("https://i.imgur.com/siDZu9V.jpeg")} />
                </div>
        </div>

        <iframe className="content" xs={{ width: "100%" }} width="100%" maxWidth={'100%'} height="300" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d826431.0!2d169.7616486!3d-45.3138377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4e33df33740f9d01%3A0x86b34c18bafc48d4!2sNZ%20Roof%20Painting!5e0!3m2!1sen!2s!4v1732752000000!5m2!1sen!2s" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

        <ShowCase first_image='https://i.imgur.com/YUlK1gw.jpeg' second_image='https://i.imgur.com/sWYLVAG.jpeg' />
    </div>
}

export default Home;